// World 7 (Aurora) — third paid-tier world. First of the W7-W10 hard tier.
// Generator: tools/generate-parallel.mjs --world 7 (180s solver budget).
// Pool of 55 accepted candidates across 4 r=3 configs at tileCount 12/13/14/15.
// Progression: L1-L9 d=7 climbing branching 16.66 → 22.04; L10 is the world's
// d=8 climax at branching 20.96 (tiles=13). The handoff originally aimed for a
// 3/4/3 split across d=7/8/9, but the solver can't reliably prove d=8/9 even
// at 6× the v0.3.0 budget; W7 instead ships as an opener that ramps through
// d=7 branching and lands one d=8 at the top to signal the climb continues
// into W8+. Character = long chains at tight geometries.
import type { LevelDef } from '@tessera/engine';
import { WORLD_7_GENERATED } from './world7-generated';

export const WORLD_7_LEVELS: LevelDef[] = [...WORLD_7_GENERATED];
